import React, { useState } from 'react';
import { Grid, AccordionDetails, AccordionSummary, Typography, Button, makeStyles, FormControlLabel } from '@material-ui/core';
import DigiSkryfForm from '../inskrywingsvorms/DigiSkryfForm';
import DigiPraatForm from '../inskrywingsvorms/DigiPraatForm';
import Accordion from '@material-ui/core/Accordion';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const useStyles = makeStyles((theme) => {
});



const KoopKrediete = () => {
    const classes = useStyles();

    const inskryfObject = [{
        'naamVan': '',
        'ouderdom': '',
        'ouerEpos': '',
        'ouerSel': '',
        'sel': '',
        'instansieNaam': '',
        'onderwerp': ''

    }];

    const floatButton = {
        "paddingLeft": "60%",
    }
    const [inskrywingArray, setInskrywingArray] = useState([]);
    const [amount, setAmount] = useState(0);
    const [showRecords, setShowRecords] = useState(false);

    function formSubmit(e) {
        e.preventDefault();
        var newArr = [];

        for (var i = 0; i < amount; i++) {
            newArr.push(inskryfObject);
        }
        setInskrywingArray(newArr);
        setShowRecords(true);
    }
    return (
        <div>
            {
                showRecords ?
                    <div>
                        {inskrywingArray.map(function (object, i) {
                            console.log('i', i);
                            return (
                                <div key={i} style={{ padding: '10px' }}>
                                    <Accordion>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1c-content"
                                            id="panel1c-header"
                                        >
                                            <div>
                                                <Typography variant="h5">Krediet {i + 1} </Typography>
                                            </div>
                                            <div style={floatButton}>
                                                <FormControlLabel
                                                    aria-label="Opdateer"
                                                    onClick={(event) => event.stopPropagation()}
                                                    onFocus={(event) => event.stopPropagation()}
                                                    control={
                                                        <Button variant="contained" size="medium" onClick={() => (console.log('buttonClicked!!', {i}))} color="primary">Stoor/Opdateer krediet</Button>
                                                    }                                                  
                                                />
                                               
                                            </div>
                                        </AccordionSummary>
                                        <AccordionDetails>

                                            <DigiPraatForm isAuth={{ userAuth: true }} userProf={{ userProfile: { id: i } }} />
                                        </AccordionDetails>
                                    </Accordion>

                                </div>)
                        })
                        }
                    </div>
                    :
                    <Grid container justify="center">

                        <Grid item>



                            <p>Koop krediete</p>
                            
                                <input type="number" placeholder="Aantal krediete" onChange={(e) => setAmount(e.target.value)}></input>
                            <Button variant="contained" color="primary" onClick={(e) => formSubmit(e)}>Koop krediete</Button>
                       
                        </Grid>
                    </Grid>

            }
        </div>

    )

}

export default KoopKrediete;


// WEBPACK FOOTER //
// ./src/components/inskryf/KoopKrediete.js